import comp from "./NotificationBadgesTooltip";
export default comp;
